import React, { useState } from 'react';
import { colors } from '../../config/constants';

type SearchInputProps = {
  name?: string;
  value: string;
  placeholder?: string;
  onChange: (arg: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
  onClear: () => void;
  handleEnterKeyPress?: (arg: React.KeyboardEvent<HTMLInputElement>) => void;
};

const SearchInput = (props: SearchInputProps) => {
  const {
    name,
    value,
    placeholder,
    onChange,
    onSearch,
    onClear,
    handleEnterKeyPress,
  } = props;
  const [borderColor, setBorderColor] = useState('');
  return (
    <div className="flex w-full my-1" data-testid="SearchInput-wrapper ">
      <div
        className={`h-8 w-full sm:w-fit flex items-center border  rounded-sm  bg-white ${borderColor}`}
      >
        <div className="w-full sm:w-[300px]">
          <input
            className="text-sm sm:w-[300px] w-full h-7 pl-2 outline-none"
            placeholder={placeholder ? placeholder : 'Please search here'}
            name={name}
            value={value}
            onChange={onChange}
            onKeyDown={handleEnterKeyPress}
            autoComplete="off"
            onFocus={() => {
              setBorderColor('border-[#b3f2e9] shadow-sm');
            }}
            onBlur={() => {
              setBorderColor('');
            }}
          />
        </div>

        <div onClick={onClear} className="h-8 w-8 flex items-center justify-center">
          {value.length > 0 && (
            <i className={` fa-solid fa-xmark cursor-pointer text-[gray]`}></i>
          )}
        </div>

        <div
          onClick={onSearch}
          className={`h-8 w-8 flex items-center justify-center text-white ${colors.primary} cursor-pointer`}
        >
          <i className="fa-solid fa-magnifying-glass"></i>
        </div>
      </div>
    </div>
  );
};

export default SearchInput;
